import { IUnbookProgramExecutionUsersActionPayload } from '../interfaces/program-execution-unbook-users-action.action-payload.interface';

export class UnbookProgramExecutionUsersCommand {
    bookings?: { user_id: number; execution_id: number }[];
    user_ids?: number[];
    remove_from_program: boolean;
    notify?: number;

    constructor(payload: IUnbookProgramExecutionUsersActionPayload) {
        this.remove_from_program = payload.removeFromProgram;

        if (payload.bookings?.length) {
            this.bookings = payload.bookings.map((booking) => ({
                user_id: Number(booking.user_id),
                execution_id: Number(booking.execution_id),
            }));
        }

        if (payload.userIds?.length) {
            this.user_ids = payload.userIds.map((userId) => Number(userId));
        }

        if (payload.notify !== undefined) {
            this.notify = payload.notify;
        }
    }
}
